import React, { createContext, useContext, useEffect, useState } from 'react';

import { isAgeVerified } from '../services/cookieService';

interface AgeVerificationContextType {
  isVerified: boolean;
  setVerified: (verified: boolean) => void;
}

const AgeVerificationContext = createContext<AgeVerificationContextType | undefined>(undefined);

interface AgeVerificationProviderProps {
  children: React.ReactNode;
}

export const AgeVerificationProvider: React.FC<AgeVerificationProviderProps> = ({ children }) => {
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    // Check if the user has already verified their age
    const verified = isAgeVerified();
    setIsVerified(verified);
    setIsLoading(false);
  }, []);

  const setVerified = (verified: boolean) => {
    setIsVerified(verified);
  };

  // Show loading state while checking cookies
  if (isLoading) {
    return null;
  }

  return (
    <AgeVerificationContext.Provider value={{ isVerified, setVerified }}>
      {children}
    </AgeVerificationContext.Provider>
  );
};

export const useAgeVerification = (): AgeVerificationContextType => {
  const context = useContext(AgeVerificationContext);
  if (context === undefined) {
    throw new Error('useAgeVerification must be used within an AgeVerificationProvider');
  }
  return context;
};
